'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const accessibleTarget = {
  accessible: false,
  accessibleTitle: null,
  accessibleHint: null,
  tabIndex: 0,
  _accessibleActive: false,
  _accessibleDiv: null,
  accessibleType: "button",
  accessiblePointerEvents: "auto",
  accessibleChildren: true,
  renderId: -1
};

exports.accessibleTarget = accessibleTarget;
//# sourceMappingURL=accessibleTarget.js.map
